import React, { PropTypes } from 'react';
import style from './hero.css';

export default function Hero({
  description,
  background,
  darkness,
  ratio,
  actionButton,
  fontSize,
  children,
}) {
  return (
    <div
      id="hero"
      className={style.container}
      style={{
        background: `url('${background}') no-repeat center`,
        backgroundSize: 'cover',
        backgroundColor: `rgba(0,0,0,${darkness})`,
        backgroundBlendMode: 'multiply',
        height: `${ratio}vh`,
      }}
    >
      <section className={style.content}>
        {children && <h1 className={style.caption} style={{ fontSize }}>{children}</h1>}
        {description && <p className={style.description}>{description}</p>}
        {actionButton}
      </section>
    </div>
  );
}

Hero.defaultProps = {
  ratio: '100',
  darkness: '0.3',
  fontSize: '1.8em',
};

Hero.propTypes = {
  background: PropTypes.string.required,
  children: PropTypes.element.required,
  description: PropTypes.string,
  darkness: PropTypes.string,
  fontSize: PropTypes.string,
  actionButton: PropTypes.element,
  ratio: PropTypes.string,
};
